import React, { FC, useEffect, useState } from 'react';
import './Dashboard.scss';
import clsx from 'clsx';
import { Widget } from '../../components/dashboard/Widget';
import { LineChart } from '../../components/charts/lineChart';
import { moneyConverter } from '../../utils/numberConverter';
import { LostPaymentsWidget } from '../../components/dashboard/LostPaymentsWidget';
import { Spinner } from '../../components/Spinner';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import moment from 'moment';
import { categoryFormatter } from '../../utils/chart-helper';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { ADMIN_GROUPS } from '../login/Login';
import { useOrdersContext } from '../../store/order/order-context';
import { fetchDashboardData } from '../../store/order/actions/dashboard';
import axios from 'axios';
import { BASE_URL } from '../../../config/environmentConfig';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { IAuthState } from '../../redux/AuthRedux';
import { v4 as uuidv4 } from 'uuid';

// const firstChart = {
//     series: [{
//         name: '',
//         data: []
//     }],
//     // series: [{
//     //     name: "data 1",
//     //     data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
//     // }],
//     categories: {
//         // hour: ['12.00', '13.00', '14.00', '15.00', '16.00', '17.00', '18.00', '19.00', '20.00'],
//         // day: ['1 Aug', '2 Aug', '3 Aug', '4 Aug', '5 Aug', '6 Aug', '7 Aug', '8 Aug', '9 Aug'],
//         // week: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue'],
//         // month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
//         // year: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
//         // all: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
//     },
// };

// const secondChart = {
//     series: [
//         {
//             name: "data 1",
//             data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
//         },
//         {
//             name: "data 2",
//             data: [0, 23, 9, 32, 56, 62, 20, 122, 130]
//         },
//         {
//             name: "data 3",
//             data: [148, 91, 69, 62, 49, 51, 35, 41, 10]
//         },
//         {
//             name: "data 4",
//             data: [23, 4, 43, 54, 56, 76, 78, 100, 111]
//         },
//     ],
//     categories: {
//         hour: ['12.00', '13.00', '14.00', '15.00', '16.00', '17.00', '18.00', '19.00', '20.00'],
//         day: ['1 Aug', '2 Aug', '3 Aug', '4 Aug', '5 Aug', '6 Aug', '7 Aug', '8 Aug', '9 Aug'],
//         week: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue'],
//         month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
//         year: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
//         all: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
//     },
// };

export enum DATE_TYPE {
	DAY = 'day',
	WEEK = 'week',
	MONTH = 'month',
	YEAR = 'year'
}

const paymentChartOptions = [
	{
		name: 'DASHBOARD.DAY',
		value: DATE_TYPE.DAY
	},
	{
		name: 'DASHBOARD.WEEK',
		value: DATE_TYPE.WEEK
	},
	{
		name: 'DASHBOARD.MONTH',
		value: DATE_TYPE.MONTH
	},
	{
		name: 'DASHBOARD.YEAR',
		value: DATE_TYPE.YEAR
	}
];

interface IStatistics {
	value: string;
	name: string;
}

const PAYMENT_PROCESSING_STATISTICS = (t): IStatistics[] => [
	{ value: 'daily_Processed_Payments', name: t('DASHBOARD.PROCESSED_PAYMENTS') },
	{ value: 'daily_Successful_Payments', name: 'Successful Payments' },
	{ value: 'daily_Declined_Payments', name: t('DASHBOARD.DECLINE_PAYMENTS') },
];

const FLEXCHARGE_STATISTICS = (t): IStatistics[] => [
	{ value: 'declinedPaymentsProcessed', name: t('DASHBOARD.PROCESSED_PAYMENTS') },
	{ value: 'declinedEligible_Payments', name: 'Eligible Payments' },
	{ value: 'declined_Payments', name: t('DASHBOARD.DECLINE_PAYMENTS') },
];

// export const Dashboard = (): JSX.Element => {
// 	const [payment, setPayment] = useState<DATE_TYPE>(DATE_TYPE.MONTH);
// 	const [data, setData] = useState<any>({});
// 	const { orderContextState, dispatch } = useOrdersContext();
// 	const {
// 		dashboardData,
// 		isDashboardDataLoading,
// 		reportCache,
// 	} = orderContextState;
//
// 	const { merchantState: { chosenMerchant }} = useMerchants();
// 	const { t } = useTranslation();
//
// 	const userData: any = useSelector<RootState>(({ auth }) => auth.userData, shallowEqual);
// 	const isSuperAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN);
// 	const isPartnerAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.PARTNER_ADMIN);
// 	const isIntegrationPartnerAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN);
// 	const isMerchantAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.MERCHANT_ADMIN);
//
// 	const getFirstDate = (): string => {
// 		switch (payment) {
// 			case DATE_TYPE.DAY: {
// 				return moment().format('YYYY-MM-D');
// 			}
// 			case DATE_TYPE.WEEK: {
// 				return moment().subtract(6, 'days').format('YYYY-MM-D');
// 			}
// 			case DATE_TYPE.MONTH: {
// 				return moment().subtract(1, 'months').add(1, 'days').format('YYYY-MM-D');
// 			}
// 			case DATE_TYPE.YEAR: {
// 				return moment().subtract(1, 'years').add(1, 'days').format('YYYY-MM-D');
// 			}
// 		}
// 	};
//
// 	useEffect(() => {
// 		if (!isSuperAdmin && isMerchantAdmin) {
// 			if (reportCache[payment]) {
// 				setData(reportCache[payment]);
// 			} else {
// 				void fetchDashboardData(dispatch, getFirstDate, chosenMerchant, payment, reportCache, isMerchantAdmin);
// 			}
// 			return;
// 		}
// 		if (chosenMerchant) {
// 			if (reportCache[chosenMerchant]) {
// 				if (reportCache[chosenMerchant][payment]) {
// 					setData(reportCache[chosenMerchant][payment]);
// 				} else {
// 					void fetchDashboardData(dispatch, getFirstDate, chosenMerchant, payment, reportCache);
// 				}
// 			} else {
// 				void fetchDashboardData(dispatch, getFirstDate, chosenMerchant, payment, reportCache);
// 			}
// 		} else {
// 			setData({});
// 		}
// 	}, [payment, chosenMerchant, dashboardData]);
//
// 	const firstChart = {
// 		series: [],
// 		categories: []
// 	};
//
// 	const secondChart = {
// 		series: [],
// 		categories: []
// 	};
//
// 	FLEXCHARGE_STATISTICS(t).forEach((el, index) => {
// 		if (index === 0) {
// 			data?.flexChargeDeclinedPaymentsReceived?.[el.value]?.forEach(item => {
// 				// secondChart.categories.push(getFormattedDate(item.date, 'yyyy-MM-dd'));
// 				secondChart.categories.push(categoryFormatter(item.date, payment));
// 			});
// 		}
//
// 		const values = data?.flexChargeDeclinedPaymentsReceived?.[el.value]?.map(item => item.value);
// 		secondChart.series.push({ data: values ? values : [], name: el.name });
// 	});
//
// 	PAYMENT_PROCESSING_STATISTICS(t).forEach((el, index) => {
// 		if (index === 0) {
// 			data?.paymentProcessingStatistics?.[el.value]?.forEach(item => {
// 				// firstChart.categories.push(getFormattedDate(item.date, 'yyyy-MM-dd'));
// 				firstChart.categories.push(categoryFormatter(item.date, payment));
// 			});
// 		}
//
// 		const values = data?.paymentProcessingStatistics?.[el.value]?.map(item => item.value);
// 		firstChart.series.push({ data: values ? values : [], name: el.name });
// 	});
//
// 	// TODO template for empty data
// 	// return (
// 	//     <div className="dashboard-no-data bg-white rounded-3">
// 	//         <span
// 	//             className="indicator-progress position-absolute fs-4"
// 	//             style={{
// 	//                 display: 'block',
// 	//                 top: '50%',
// 	//                 left: '40%'
// 	//             }}
// 	//         >
// 	//             No data found...
// 	// 		</span>
// 	//     </div>
// 	// )
//
// 	// TODO check partners permissions
// 	if ((isSuperAdmin || isPartnerAdmin || isIntegrationPartnerAdmin) && !chosenMerchant) {
// 		return (
// 			<div className="card">
// 				<div className="card-body empty-dashboard-height">
// 					<div className="d-flex align-items-center justify-content-center h-100 w-100 fs-1 fw-bolder">
// 						To view the dashboard, select a merchant from the top dropdown
// 					</div>
// 				</div>
// 			</div>
// 		);
// 	}
//
// 	return (
// 		<div>
// 			<div className="card mb-5">
// 				<div className="card-body">
// 					<div className="dashboard-title-wrapper d-flex">
// 						<h2 className="dashboard-title">Payment processing statistics</h2>
// 						<div className="dashboard-chart-list">
// 							{
// 								paymentChartOptions.map(el => (
// 									<div
// 										onClick={(): void => setPayment(el.value)}
// 										className={clsx('dashboard-chart-list-item',
// 											{ active: el.value === payment })} key={el.value}
// 									>
// 										{t(el.name)}
// 									</div>)
// 								)
// 							}
// 						</div>
// 					</div>
// 					<LineChart
// 						categories={isDashboardDataLoading ? [] : firstChart.categories}
// 						series={isDashboardDataLoading ? [] : firstChart.series}
// 						currencyCode={data?.currencyCode}
// 						type={payment}
// 					/>
// 					<div className="chart-description">
// 						<div className="chart-description-item col-xs-12 col-sm-12 col-md-6 col-lg-4">
// 							<div className="chart-description-item-title">
// 								{t('DASHBOARD.PROCESSED_PAYMENTS')}
// 							</div>
//
// 							<Widget
// 								payments_Count={data?.paymentProcessingStatistics?.processed_Payments_Count}
// 								payments_TotalAmount={data?.paymentProcessingStatistics?.processed_Payments_TotalAmount}
// 								currencySymbol={data?.currencySymbol}
// 								currencyCode={data?.currencyCode}
// 							/>
//
// 							<div className="dashboard-item-description">
// 								{t('DASHBOARD.TOTAL_NUMBER_PROCESSED_PAYMENTS')}
// 							</div>
// 						</div>
//
// 						<div className="chart-description-item col-xs-12 col-sm-12 col-md-6 col-lg-4">
// 							<div className="chart-description-item-title">
// 								{t('DASHBOARD.SUCCESSFUL_PAYMENTS')}
// 							</div>
//
// 							<Widget
// 								payments_Count={data?.paymentProcessingStatistics?.successful_Payments_Count}
// 								payments_TotalAmount={data?.paymentProcessingStatistics?.successful_Payments_TotalAmount}
// 								currencySymbol={data?.currencySymbol}
// 								currencyCode={data?.currencyCode}
// 							/>
// 							<div className="dashboard-item-description">
// 								{t('DASHBOARD.TOTAL_NUMBER_SUCCESSFUL_PAYMENTS')}
// 							</div>
// 						</div>
//
// 						<div className="chart-description-item col-xs-12 col-sm-12 col-md-6 col-lg-4">
// 							<div className="chart-description-item-title">
// 								{t('DASHBOARD.DECLINE_PAYMENTS')}
// 							</div>
//
// 							<Widget
// 								payments_Count={data?.paymentProcessingStatistics?.declined_Payments_Count}
// 								payments_TotalAmount={data?.paymentProcessingStatistics?.declined_Payments_TotalAmount}
// 								currencySymbol={data?.currencySymbol}
// 								currencyCode={data?.currencyCode}
// 							/>
//
// 							<div className="dashboard-item-description">
// 								{t('DASHBOARD.TOTAL_NUMBER_DECLINED_PAYMENTS')}
// 							</div>
// 						</div>
//
// 					</div>
// 				</div>
// 			</div>
//
// 			<div className="dashboard-group row">
// 				<div className="dashboard-group-item col-xs-12 col-sm-12 col-lg-3 col-md-6 col-sm-6">
// 					<div className="dashboard-group-item-inner bg-white rounded-3">
// 						<div className="dashboard-group-item-title">
// 							{t('DASHBOARD.LOST_ORDERS')}
// 						</div>
// 						<LostPaymentsWidget
// 							lostCount={data?.paymentProcessingStatistics?.lost_Orders_DueToDeclines_Count}
// 							lostAmount={data?.paymentProcessingStatistics?.lost_Orders_DueToDeclines_Amount}
// 							currencySymbol={data?.currencySymbol}
// 							currencyCode={data?.currencyCode}
// 							isOrders
// 						/>
// 						<div className="dashboard-item-description">
// 							{t('DASHBOARD.TOTAL_NUMBER_ORDERS_DECLINED_PAYMENTS')}
// 						</div>
// 					</div>
// 				</div>
//
//
// 				<div className="dashboard-group-item col-xs-12 col-sm-12 col-lg-3 col-md-6 col-sm-6">
// 					<div className="dashboard-group-item-inner bg-white rounded-3">
// 						<div className="dashboard-group-item-title">
// 							{t('DASHBOARD.AVERAGE_ORDER_LOST')}
// 						</div>
// 						{
// 							isDashboardDataLoading
// 								? <Spinner/>
// 								: (
// 									<div className="dashboard-item-data">
// 										<div className="dashboard-item-data-el">
// 											{data?.currencySymbol}
// 											{moneyConverter(data?.paymentProcessingStatistics?.avg_LostValue_DueToDeclines_Amount)}{' '}
// 											<span className="dashboard-item-small">{data?.currencyCode}</span>
// 										</div>
// 									</div>
// 								)
// 						}
//
// 						<div className="dashboard-item-description">
// 							{t('DASHBOARD.AVERAGE_ORDERS_LOST')}
// 						</div>
// 					</div>
// 				</div>
//
// 				<div className="dashboard-group-item col-xs-12 col-sm-12 col-lg-3 col-md-6 col-sm-6">
// 					<div className="dashboard-group-item-inner bg-white rounded-3">
// 						<div className="dashboard-group-item-title">
// 							{t('DASHBOARD.LOST_CLIENTS_DECLINED_PAYMENTS')}
// 						</div>
// 						<LostPaymentsWidget
// 							lostCount={data?.paymentProcessingStatistics?.lost_Clients_DueToDeclines_Count}
// 							lostAmount={data?.paymentProcessingStatistics?.lost_Clients_DueToDeclines_Amount}
// 							currencySymbol={data?.currencySymbol}
// 							currencyCode={data?.currencyCode}
//
// 						/>
//
// 						<div className="dashboard-item-description">
// 							{t('DASHBOARD.TOTAL_NUMBER_CLIENTS_DECLINED_PAYMENTS')}
// 						</div>
// 					</div>
// 				</div>
//
// 				<div className="dashboard-group-item col-xs-12 col-sm-12 col-lg-3 col-md-6 col-sm-6">
// 					<div className="dashboard-group-item-inner bg-white rounded-3">
// 						<div className="dashboard-group-item-title">
// 							{t('DASHBOARD.AVERAGE_CLIENT_LOST')}
// 						</div>
// 						{
// 							isDashboardDataLoading
// 								? <Spinner/>
// 								: (
// 									<div className="dashboard-item-data">
// 										<div className="dashboard-item-data-el">
// 											{data?.currencySymbol}
// 											{moneyConverter(data?.paymentProcessingStatistics?.avg_LostValue_LostClients_DueToDeclines_Amount)}{' '}
// 											<span className="dashboard-item-small">{data?.currencyCode}</span>
// 										</div>
// 									</div>
// 								)
// 						}
// 						<div className="dashboard-item-description">
// 							{t('DASHBOARD.AVERAGE_CLIENTS_LOST')}
// 						</div>
// 					</div>
// 				</div>
// 			</div>
//
// 			<div className="dashboard-total rounded-3 d-flex">
// 				<div className="col-xs-8 col-sm-8 col-md-8 col-lg-5">
// 					<div className="dashboard-total-title">
// 						{t('DASHBOARD.TOTAL_REVENUE')}
// 					</div>
// 					<div className="dashboard-total-subtitle">
// 						{t('DASHBOARD.TOTAL_NUMBER_CLIENTS_&_ORDERS_DECLINED_PAYMENTS')}
// 					</div>
// 				</div>
// 				<div className="col-xs-4 col-sm-4 col-md-4 col-lg-2">
// 					<div className="dashboard-item-data-el">
// 						{data?.currencySymbol}
// 						{moneyConverter(data?.paymentProcessingStatistics?.lostRevenue_DueToDeclines_Amount)}{' '}
// 						<span className="dashboard-item-small">{data?.currencyCode}</span>
// 					</div>
// 				</div>
// 				<div className="col-xs-12 col-sm-12 col-md-12 col-lg-5">
// 					<div className="dashboard-total-bar-label">
// 						<div className="dashboard-total-bar-title">
// 							{t('DASHBOARD.REVENUE_LOST')}
// 						</div>
// 						<div className="dashboard-total-bar-value">
// 							{data?.paymentProcessingStatistics?.lostRevenue_DueToDeclines_Percentage} %
// 						</div>
// 					</div>
// 					<progress
// 						max="100"
// 						value={data?.paymentProcessingStatistics?.lostRevenue_DueToDeclines_Percentage
// 							? data?.paymentProcessingStatistics?.lostRevenue_DueToDeclines_Percentage
// 							: 0
// 						}
// 					/>
// 				</div>
// 			</div>
//
// 			<div className="card mb-5">
// 				<div className="card-body">
// 					<h2 className="dashboard-title ">
// 						{t('DASHBOARD.FLEXCHARGE_STATISTIC')}
// 					</h2>
// 					<LineChart
// 						categories={isDashboardDataLoading ? [] : secondChart.categories}
// 						series={isDashboardDataLoading ? [] : secondChart.series}
// 						currencyCode={data?.currencyCode}
// 						type={payment}
// 					/>
// 					<div className="chart-description">
// 						<div className="chart-description-item  col-md-4 col-lg-4">
// 							<div className="chart-description-item-title">
// 								{t('DASHBOARD.DECLINE_PAYMENTS_RECEIVED')}
// 							</div>
//
// 							<Widget
// 								payments_Count={data?.flexChargeDeclinedPaymentsReceived?.declined_Payments_Count}
// 								payments_TotalAmount={data?.flexChargeDeclinedPaymentsReceived?.declined_Payments_TotalAmount}
// 								currencySymbol={data?.currencySymbol}
// 								currencyCode={data?.currencyCode}
// 							/>
//
// 							<div className="dashboard-item-description">
// 								{t('DASHBOARD.TOTAL_NUMBER_DECLINED_PAYMENTS_PRESENTED')}
// 							</div>
// 						</div>
//
// 						<div className="chart-description-item col-xs-12 col-sm-12 col-md-6 col-lg-4">
// 							<div className="chart-description-item-title">
// 								{t('DASHBOARD.DECLINE_PAYMENTS_ELIGIBLE')}
// 							</div>
//
// 							<Widget
// 								payments_Count={data?.flexChargeDeclinedPaymentsReceived?.declined_EligiblePayments_Count}
// 								payments_TotalAmount={data?.flexChargeDeclinedPaymentsReceived?.declined_EligiblePayments_TotalAmount}
// 								currencySymbol={data?.currencySymbol}
// 								currencyCode={data?.currencyCode}
// 							/>
//
// 							<div className="dashboard-item-description">
// 								{t('DASHBOARD.TOTAL_NUMBER_DECLINED_PAYMENTS_ELIGIBLE')}
// 							</div>
// 						</div>
//
// 						<div className="chart-description-item col-xs-12 col-sm-12 col-md-6 col-lg-4">
// 							<div className="chart-description-item-title">
// 								{t('DASHBOARD.DECLINE_PAYMENTS_PROCESSED')}
// 							</div>
//
// 							<Widget
// 								payments_Count={data?.flexChargeDeclinedPaymentsReceived?.declined_PaymentsProcessed_Count}
// 								payments_TotalAmount={data?.flexChargeDeclinedPaymentsReceived?.declined_PaymentsProcessed_TotalAmount}
// 								currencySymbol={data?.currencySymbol}
// 								currencyCode={data?.currencyCode}
// 							/>
//
// 							<div className="dashboard-item-description">
// 								{t('DASHBOARD.TOTAL_NUMBER_DECLINED_PAYMENTS_PROCESSED')}
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
//
// 			<div className="dashboard-total rounded-3 d-flex">
// 				<div className="col-xs-8 col-sm-8 col-md-8 col-lg-5">
// 					<div className="dashboard-total-title red">
// 						{t('DASHBOARD.TOTAL_REVENUE_FLEXCHARGE')}
// 					</div>
// 					<div className="dashboard-total-subtitle">
// 						{t('DASHBOARD.TOTAL_NUMBER_CLIENTS_&_ORDERS_DECLINED_PAYMENTS')}
// 					</div>
// 				</div>
// 				<div className="col-xs-4 col-sm-4 col-md-4 col-lg-2">
// 					<div className="dashboard-item-data-el red">
// 						{data?.currencySymbol}
// 						{moneyConverter(data?.flexChargeDeclinedPaymentsReceived?.savedRevenue_By_FlexCharge_Amount)}{' '}
// 						<span className="dashboard-item-small">{data?.currencyCode}</span>
// 					</div>
// 				</div>
// 				<div className="col-xs-12 col-sm-12 col-md-12 col-lg-5">
// 					<div className="dashboard-total-bar-label">
// 						<div className="dashboard-total-bar-title">
// 							{t('DASHBOARD.REVENUE_DELIVERED_FLEXCHARGE')}
// 						</div>
// 						<div className="dashboard-total-bar-value">
// 							{data?.flexChargeDeclinedPaymentsReceived?.savedRevenue_By_FlexCharge_Percentage ?
// 								data?.flexChargeDeclinedPaymentsReceived?.savedRevenue_By_FlexCharge_Percentage :
// 								0
// 							} %
// 						</div>
// 					</div>
// 					<progress
// 						className="red"
// 						max="100"
// 						value={data?.flexChargeDeclinedPaymentsReceived?.savedRevenue_By_FlexCharge_Percentage ?
// 							data?.flexChargeDeclinedPaymentsReceived?.savedRevenue_By_FlexCharge_Percentage : 0}
// 						color="#E5575B"
// 					/>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

const Dashboard: FC = () => {
	const [url, setUrl] = useState('');
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const { merchantState } = useMerchants();
	const { chosenMerchant } = merchantState;

	const userData: any = useSelector<RootState>(({ auth }) => auth.userData, shallowEqual);
	const isSuperAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN);
	const isPartnerAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.PARTNER_ADMIN);
	const isIntegrationPartnerAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN);
	const isMerchantAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.MERCHANT_ADMIN);

	useEffect(() => {
		const fetchUrl = async (): Promise<void> => {
			try {
				let browserSessionId = sessionStorage.getItem('browserSessionId');

				if (!browserSessionId) {
					browserSessionId = uuidv4();
					sessionStorage.setItem('browserSessionId', browserSessionId);
				}

				if (checkRoles(authUser, CLAIMS.SUPER_ADMIN) && chosenMerchant) {
					const response = await axios.get(`${BASE_URL.MERCHANTS}/Analytics/admin/dashboard?browserSessionId=${browserSessionId}&mid=${chosenMerchant}`);
					setUrl(response.data.dashboardUrl);
				} else if (checkRoles(authUser, CLAIMS.PARTNER_ADMIN) && chosenMerchant) {
					const response = await axios.get(`${BASE_URL.MERCHANTS}/Analytics/partner/dashboard?browserSessionId=${browserSessionId}&mid=${chosenMerchant}`);
					setUrl(response.data.dashboardUrl);
				} else if (checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN) && chosenMerchant) {
					const response = await axios.get(`${BASE_URL.MERCHANTS}/Analytics/integrationpartner/dashboard?browserSessionId=${browserSessionId}&mid=${chosenMerchant}`);
					setUrl(response.data.dashboardUrl);
				} else if (checkRoles(authUser, CLAIMS.MERCHANT_ADMIN)) {
					const response = await axios.get(`${BASE_URL.MERCHANTS}/Analytics/merchant/dashboard?browserSessionId=${browserSessionId}`);
					setUrl(response.data.dashboardUrl);
				}

			} catch (error) {
				console.error('Failed to fetch URL', error);
			}
		};

		fetchUrl();
	}, [chosenMerchant]);

	if ((isSuperAdmin || isPartnerAdmin || isIntegrationPartnerAdmin) && (!chosenMerchant || !url))
	{
		return (
			<div className="card">
				<div className="card-body empty-dashboard-height">
					<div className="d-flex align-items-center justify-content-center h-100 w-100 fs-1 fw-bolder">
						To view the dashboard, select a merchant from the top dropdown
					</div>
				</div>
			</div>
		);
	}

	return (
		// <div style={{ width: 'calc(100vw - SIDEBAR_WIDTH)', height: 'calc(100vh - HEADER_HEIGHT)' }}>
		<div style={{ width: '100%', height: '100%' }}>
			{url && <iframe src={url} title="Analytics" style={{ width: '100%', height: '100%' }} rel="noopener noreferrer" />}
		</div>
	);
};

export default Dashboard;
